import { Package, DollarSign, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const STEPS = [
  {
    step: "01",
    title: "Text or Call Us",
    description: "Send us a photo of your supplies or call (904) 955-9646. We'll give you a fast quote!",
    icon: Package
  },
  {
    step: "02",
    title: "Meet Up Locally",
    description: "We come to you! Meet at a convenient public location - Wawa, Starbucks, or nearby parking lot.",
    icon: DollarSign
  },
  {
    step: "03",
    title: "Get Paid Instantly",
    description: "Same day cash on the spot! No waiting, no shipping delays - walk away with money in hand.",
    icon: CheckCircle
  }
];

export const HowItWorks = ({ onOpenForm }) => (
  <section id="how-it-works" className="py-24 md:py-32 bg-white" data-testid="how-it-works-section">
    <div className="container-custom">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-[#1F2937] mb-4" style={{ fontFamily: "Manrope" }}>
          How It Works
        </h2>
        <p className="text-lg text-[#4B5563] max-w-2xl mx-auto">
          Selling your unused test strips is simple. Just follow these three easy steps.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {STEPS.map((item) => (
          <div
            key={item.step}
            className="relative p-8 rounded-2xl border border-gray-100 bg-white hover:shadow-lg transition-shadow"
            data-testid={`step-${item.step}`}
          >
            <span className="text-6xl font-bold text-[#0F5132]/10 absolute top-4 right-6" style={{ fontFamily: "Manrope" }}>
              {item.step}
            </span>
            <div className="w-14 h-14 bg-[#0F5132]/10 rounded-xl flex items-center justify-center mb-6">
              <item.icon className="w-7 h-7 text-[#0F5132]" />
            </div>
            <h3 className="text-xl font-semibold text-[#1F2937] mb-3" style={{ fontFamily: "Manrope" }}>
              {item.title}
            </h3>
            <p className="text-[#4B5563] leading-relaxed">{item.description}</p>
          </div>
        ))}
      </div>

      <div className="text-center mt-12">
        <Button
          onClick={onOpenForm}
          className="bg-[#EA580C] hover:bg-[#C2410C] text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg"
          data-testid="how-it-works-sell-btn"
        >
          Start Selling Now
        </Button>
      </div>
    </div>
  </section>
);
